import { FC, useMemo } from 'react';

import { usePasswordRecovery } from '~/modules/auth/hooks/usePasswordRecovery';

import { AuthHeader } from '~/shared/components/AuthHeader';
import { PasswordRecoverySteps } from '../../components/PasswordRecoverySteps';

import { Container } from './styles';

export const PasswordRecovery: FC = () => {
  const { currentStep, selectedMethod } = usePasswordRecovery();

  const headerSubtitle = useMemo(() => {
    return {
      1: 'Qual a forma de recuperação?',
      2:
        selectedMethod === 'email'
          ? 'Informe seu e-mail para enviarmos um código de recuperação'
          : 'Informe seu telefone para enviarmos um código de recuperação',
      3: 'Qual o código de recuperação?',
      4: 'Escolha uma nova senha segura',
    }[currentStep];
  }, [currentStep, selectedMethod]);

  return (
    <Container>
      <AuthHeader title="Recupere sua conta" subtitle={headerSubtitle} />

      <PasswordRecoverySteps />
    </Container>
  );
};
